import React from 'react';
import { TouchableOpacity, View, Text, StyleSheet } from 'react-native';
import CS from '../constants/Styles';
import Colors from '../constants/Colors';

export default function Button({...props}){

  const getButtonColor = () => {
    if (props.disabled) { return Colors.lightGrey; }
    switch (props.color){
      case 'blue':
        return Colors.lightBlue2;
      case 'red':
        return Colors.red;
      case 'grey':
        return Colors.lightGrey;
      case 'darkBlue':
        return Colors.blue;
      case 'google':
        return Colors.google;
      case 'facebook':
        return Colors.facebook;
      case 'yellow':
      default:
        return Colors.yellow;
    }
  }
  const getButtonBorderColor = () => {
    if (props.disabled) { return Colors.lightGrey; }
    switch (props.color) {
      case 'blue':
        return Colors.lightBlue2;
      case 'red':
        return Colors.red;
      case 'grey':
        return Colors.lightGrey;
      case 'darkBlue':
        return Colors.lightBlue2;
      case 'google':
        return Colors.google;
      case 'facebook':
        return Colors.facebook;
      case 'yellow':
      default:
        return Colors.yellow;
    }
  }

  const getButtonTextColor = () => {
    if (props.disabled) { return Colors.mediumGrey; }
    switch (props.color) {
      case 'blue':
        return Colors.blue2;
      case 'red':
        return Colors.lightText;
      case 'grey':
        return Colors.mediumGrey;
      case 'darkBlue':
        return Colors.lightBlue2;
      case 'google':
      case 'facebook':
        return Colors.white;
      case 'yellow':
      default:
        return Colors.darkText;
    }
  }

  const styles = StyleSheet.create({
    buttonColor: {
      backgroundColor: getButtonColor(),
      borderWidth: 1,
      borderColor: getButtonBorderColor(),
    },
    buttonTextColor: {
      color: getButtonTextColor(),
    },
  });

  const inner = () => {
    return (
      <View style={[CS.button, styles.buttonColor, props.buttonStyle && props.buttonStyle]}>
        {props.icon && props.icon}
        <Text style={[CS.buttonText, styles.buttonTextColor, props.buttonTextStyle && props.buttonTextStyle]}>{props.text}</Text>
      </View>
    )
  }

  if(props.disabled === undefined || !props.disabled){
    return (
      <TouchableOpacity onPress={props.onPress()} style={[CS.buttonOuter, props.style]} activeOpacity={0.6}>
        {inner()}
      </TouchableOpacity>
    )
  }else{
    return (
      <View style={[CS.buttonOuter, props.style]}>
        {inner()}
      </View>
    )
  }
  
}